import { render, staticRenderFns } from "./SliderProduct.vue?vue&type=template&id=64c91541&scoped=true&"
import script from "./SliderProduct.vue?vue&type=script&lang=js&"
export * from "./SliderProduct.vue?vue&type=script&lang=js&"
import style0 from "./SliderProduct.vue?vue&type=style&index=0&id=64c91541&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c91541",
  null
  
)

export default component.exports